<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">
          Requerimientos para Traslado de Localización
        </h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-5">
              <router-link
                class="btn btn-sm btn-success"
                :to="{ name: 'inventario-req_traslado_loc-nuevo', params: {} }"
              >
                <i class="fa fa-pencil"></i>
                Nuevo Requerimiento de Traslado Loc
              </router-link>
            </div>
            <div class="col-sm-12">
              <div class="row justify-content-sm-end">
                <UsuariosSelectComponent
                  class="col-sm-3"
                  style="display: block"
                  :current="filter"
                  @change="filterData()"
                  @onChange="filterData()"
                />
              </div>
              <div class="form-inline justify-content-sm-end">
                <button
                  type="button"
                  @click="modalTiendaSelect()"
                  class="btn btn-dark btn-sm"
                >
                  Buscar por devolución de producto
                  <i class="fas fa-search"></i>
                </button>
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Filtrar Numero"
                  v-model="filter.numero"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    @click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData()"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filter.estado_str"
                  @change="filterData()"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <ReqTrasladoLocTableComponent :dataTabla="datatabla2" />
        <PaginationComponent
          :currentPage="currentPage"
          :data="datatabla2"
          @pagechanged="filterData"
        />
      </div>
    </div>
    <div
      class="modal fade"
      id="modalBuscarReqTraslado"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Buscar req por devolución de producto
            </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <TiendaSelectComponent
                  :incluir_en_blanco="true"
                  :current="filter"
                />
              </div>
              <div class="col-6">
                <label>Número Devolución </label>
                <input
                  type="text"
                  v-model="filter.numero_dev"
                  class="form-control"
                />
              </div>
              <div class="col-6">
                <CajaSelectComponent
                  :tienda="filter.tienda"
                  :current="filter"
                  :incluir_en_blanco="true"
                />
              </div>
              <div class="col-12">
                <ClientesSelectComponent :current="filter" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="filterData()"
            >
              Buscar
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="clearFilterData()"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import ReqTrasladoLocTableComponent from "@/components/inventario/req_traslado_localizacion/ReqTrasladoLocTableComponent";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import ClientesSelectComponent from "@/components/commons/ClientesSelectComponent";
import CajaSelectComponent from "@/components/commons/CajaSelectComponent";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    ReqTrasladoLocTableComponent,
    ClientesSelectComponent,
    CajaSelectComponent,
    TiendaSelectComponent,
    UsuarioEnTablaComponent,
    UsuariosSelectComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      datatabla2: "",
      filter: {
        tienda: "",
        estado_str: "",
        searchtext: "",
        usuario: "",
        estado: "A",
        fecha_creacion: "",
        numero: "",
      },
    };
  },
  computed: {},
  mounted() {
    this.refreshData();
  },
  methods: {
    modalTiendaSelect() {
      $("#modalBuscarReqTraslado").modal("show");
    },
    refreshData() {
      DynamicService.fetch("inv", "req_traslado_loc", {}).then((response) => {
        this.datatabla2 = response.data;
      });
    },
    filterData(page) {
      if (page) {
        this.currentPage = page;
      }
      if (this.filter.cliente_nit) {
        this.filter.cliente = this.filter.cliente_nit.nit;
      } else {
        delete this.filter.cliente;
      }
      if (this.filter.tienda == 'null') {
        delete this.filter.tienda;
      }
      DynamicService.fetch("inv", "req_traslado_loc", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        fecha_creacion: this.filter.fecha_creacion,
        tienda: this.filter.tienda,
        estado: this.filter.estado_str,
        usuario: this.filter.usuario.id,
        devolucion_cliente_e__numero: this.filter.numero_dev,
        numero: this.filter.numero,
        devolucion_cliente_e__caja: this.filter.caja,
        devolucion_cliente_e__cliente: this.filter.cliente,
      }).then((response) => {
        this.datatabla2 = response.data;
        $("#modalBuscarReqTraslado").modal("hide");
      });
    },
    clearFilterData() {
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      this.filter.numero = "";
      this.filter.usuario = "";
      this.filter.tienda = "";
      this.filterData();
    },
  },
};
</script>
